import { render, staticRenderFns } from "./CourseField.vue?vue&type=template&id=6059756e"
import script from "./CourseField.vue?vue&type=script&lang=js"
export * from "./CourseField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports